import { mapGetters } from "vuex";

import main from "./pages/dbMain.js";
import detail from "./pages/dbDetail.js";
import detailUrea from "./pages/dbDetailUrea.js";
import dbDetailUtility from "./pages/dbDetailUtility.js";


export const dbSettingsMixin = {
    data: function () {
        return {
            dasboard: [
                {
                    subject: "eis",
                    endPoint: "getEisDashboard",
                    dataNh3: detail,
                    dataUrea: detailUrea,
                    dataUtility: dbDetailUtility,
                    filter: { userId: "" }
                },
                {
                    subject: "contractor",
                    endPoint: "getContractorDashboard",
                    dataNh3: detail,
                    dataUrea: detailUrea,
                    dataUtility: dbDetailUtility,
                    filter: { userId: "" }
                },
                {
                    subject: "subSystemDashboard",
                    endPoint: "subSystemDashboard",
                    data: detail,
                    filter: { userId: "" }
                },
                {
                    subject: "detail",
                    endPoint: "detailDashboard",
                    data: detail,
                    filter: { userId: "" }
                },
                {
                    subject: "area",
                    endPoint: "areaDashboard",
                    data: detail,
                    filter: { userId: "" }
                },
            ],
        }
    },
    methods: {

        getDashboard(subject) {
            console.log("subject:", subject);
            var search = this.dasboard.filter(f =>
                f.subject == subject
            );

            if (search[0].filter.hasOwnProperty("userId")) {
                search[0].filter.userId = this.getUserInfo.id;
            }

            if (search[0].filter.hasOwnProperty("branchId")) {
                search[0].filter.branchId = this.getUserInfo.branch;
            }
            //loop through the data and update the filter id 
            return search[0];
        }


    },
    computed: {
        ...mapGetters({
            getUserInfo: "auth/getUserInfo",
        }),

    },
    created() {
    }
};